<template>
  <!-- TextInput -->
  <div class="field" :class="{ 'has-error': !!errorMessage, success: fieldMeta.valid }"
    :style="{ display: type != 'hidden' ? '' : 'none' }">
    <label v-if="label" :for="name">
      <i class="pi" :class="icon" />
      {{ label }}
    </label>
    <Editor v-if="meta?.mode == 'edit'" :id="name" v-model="inputValue" :name="name" :type="type"
      :editor-style="editorStyle" :placeholder="placeholder" :mask="mask" @blur="handleBlur"
      @update:modelValue="handleInputChange" />
    <div class="font-bold" v-html="inputValue" v-else />
  </div>
</template>

<script>
import { useField } from "vee-validate";
import { watch } from "vue";
export default {
  inject: ["meta"],
  props: {
    modelValue: {
      type: [String, Number],
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    editorStyle: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const {
      value: inputValue,
      errorMessage,
      handleBlur,
      handleChange,
      meta: fieldMeta,
    } = useField(props.name, undefined, {
      initialValue: props.modelValue,
    });

    inputValue.value = props.modelValue;
    watch(
      () => props.modelValue,
      (newValue) => {
        if (inputValue.value !== newValue) {
          inputValue.value = newValue;
        }
      },
    );

    const handleInputChange = (value) => {
      handleChange(value);
      emit("update:modelValue", value);
    };

    return {
      inputValue,
      errorMessage,
      handleBlur,
      handleInputChange,
      fieldMeta,
    };
  },
};
</script>

<style scoped>
.TextInput {
  position: relative;

  width: 100% !important;
}

input:focus {
  border-color: none;
}

.field {
  margin-bottom: 0rem;
}
</style>
